import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/es/solicitar")({
  component: ApplyLayout,
});

function ApplyLayout() {
  return <Outlet />;
}
